import React from "react";

interface ScalableImageProps {
  src: string;
  alt: string;
  width: string;
  height: string;
}

const ScalableImage: React.FC<ScalableImageProps> = ({ src, alt, width, height }) => {
  /**
   * Calculates the aspect ratio percentage based on the given width and height.
   *
   * @param width - The width as a string.
   * @param height - The height as a string.
   * @returns The aspect ratio percentage.
   */
  const getAspectRatioPercentage = (width: string, height: string): number => {
    const w = parseInt(width, 10);
    const h = parseInt(height, 10);
    return (h / w) * 100;
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingBottom: `${getAspectRatioPercentage(width, height)}%`,
        overflow: "hidden"
      }}>
      <img
        src={src}
        alt={alt}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover"
        }}
      />
    </div>
  );
};

export default ScalableImage;
